import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { serialize } from "../../utils/url";
import { IUserList } from "../types";

export interface IUserCheckIsTrainerMutationParameters {
    email: string;
}

export type IUserCheckIsTrainerMutationResult = IUserList;

/**
 * On-demand check whether an email belongs to a trainer.
 * Uses a mutation hook to model a user-triggered validation request
 * (no caching and no automatic re-fetch).
 */
export const userCheckIsTrainerMutation: IApiMutationFunction<IUserCheckIsTrainerMutationParameters> = ({ email }) => {
    return {
        method: "GET",
        url: `/users/trainer_by_email${serialize({ email }, true)}`,
    };
};

/**
 * React Query mutation hook for the trainer-by-email validation endpoint.
 */
export const useUserCheckIsTrainerMutation = createApiMutationHook<
    IUserCheckIsTrainerMutationParameters,
    IUserCheckIsTrainerMutationResult
>(userCheckIsTrainerMutation);
